<template>
    <div class="course-container">
        <headerPage></headerPage>

        <!-- 页面标题区域 -->
        <div class="page-header">
            <div class="title-wrapper">
                <!-- 返回按钮 -->
                <el-page-header @back="goHome" class="return-button"></el-page-header>
                <h2 class="page-title">我的题库</h2>
            </div>
            <div class="divider"></div>
        </div>

        <!-- 课程展示区域 -->
        <div class="course-list">
            <el-row v-if="courseList.length > 0" :gutter="20" class="course-row">
                <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="(course, index) in courseList" :key="index"
                    class="course-col">
                    <el-card class="course-card" shadow="hover">
                        <!-- 课程图片 -->
                        <img :src="course.imageUrl" class="course-image" alt="课程图片" />

                        <!-- 课程信息区域 -->
                        <div class="course-info">
                            <!-- 课程标题 -->
                            <h3 class="course-title">{{ course.title }}</h3>

                            <!-- 课程价格区域 -->
                            <p class="course-price">价格：¥{{ course.price }}</p>

                            <!-- 学习进度条区域 -->
                            <div class="progress-container">
                                <span class="progress-label">学习进度：</span>
                                <el-progress :percentage="course.progress" :stroke-width="10"
                                    :color="getProgressColor(course.progress)" style="flex: 1;"></el-progress>
                            </div>
                        </div>

                        <!-- 底部区域 -->
                        <div class="bottom">
                            <span class="course-time">{{ formatDate(course.createTime) }}</span>
                            <el-button type="primary" size="mini"
                                @click="viewDetail(course.id, course.classId)">查看详情</el-button>
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <!-- 无记录提示 -->
            <div v-else class="no-record">暂无考试记录</div>
        </div>

        <bottomPage></bottomPage>
    </div>
</template>

<script>
import headerPage from "@/components/header/header";
import bottomPage from "@/components/bottom/bottom";

import * as CourseApi from "@/api/course";

export default {
    components: {
        headerPage,
        bottomPage,
    },
    data() {
        return {
            courseList: [], // 课程数据
        };
    },
    created() {
        this.loadCourseData(); // 初始化加载课程数据
    },
    methods: {
        // 加载课程数据（从后端获取）
        async loadCourseData() {
            try {
                if (!this.$store.getters.courseIds) return;
                
                const res = await CourseApi.getMyExercisesCourses(this.$store.getters.courseIds);
                if (res.data && res.data.length > 0) {
                    this.courseList = res.data.map((item) => ({
                        id: item.id,
                        classId: item.classId,
                        title: item.courseName,
                        price: item.coursePrice,
                        imageUrl: item.courseImg,
                        progress: this.calculateProgress(item.completePercent),
                        createTime: this.formatDate(item.updateTime, '{y}-{m}-{d}'),
                    }));
                }
            } catch (error) {
                console.error("获取课程数据失败：", error);
            }
        },
        // 计算进度百分比 (completeTime 为0时显示0%)
        calculateProgress(completeTime) {
            return completeTime > 0 ? Math.min(100, completeTime / 100) : 0;
        },
        // 格式化时间戳 -> yyyy-MM-dd
        formatDate(timestamp) {
            if (!timestamp) return "";
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        // 跳转到详情页面
        viewDetail(courseId, classId) {
            this.$router.push({
                name: "questionCourseDetail",
                params: {
                    courseId: courseId,
                    classId: classId
                },
            });
        },
        // 根据进度动态返回颜色
        getProgressColor(progress) {
            if (progress < 50) {
                return "#f56c6c"; // 低进度红色
            } else if (progress < 80) {
                return "#e6a23c"; // 中等进度橙色
            } else {
                return "#67c23a"; // 高进度绿色
            }
        },
        // 返回首页
        goHome() {
            this.$router.push('/');
        }
    },
};
</script>

<style scoped>
/* 页面容器样式 */
.course-container {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding: 20px;
}

/* 课程列表样式 */
.course-list {
    max-width: 1200px;
    margin: 20px auto;
}

/* 页头区域样式 */
.page-header {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
}

.title-wrapper {
    display: flex;
    align-items: center;
}

/* 调整返回按钮和标题之间的间距 */
.return-button {
    margin-top: 10px;
    margin-right: 10px;
}

/* 页标题样式 - 左对齐 */
.page-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    text-align: left;
}

/* 分割线样式 - 灰色铺满 */
.divider {
    width: 100%;
    height: 2px;
    background-color: #dcdfe6;
    margin-bottom: 20px;
}

/* 课程卡片样式 */
.course-card {
    border-radius: 10px;
    overflow: hidden;
    transition: transform 0.3s;
}

/* 增加卡片的上下间距 */
.course-col {
    margin-bottom: 20px;
}

.course-card:hover {
    transform: translateY(-5px);
}

/* 课程图片样式 */
.course-image {
    width: 100%;
    height: 180px;
    object-fit: cover;
}

/* 课程信息区域 */
.course-info {
    padding: 0 14px 14px 14px;
    background-color: #f9f9f9;
    border-top: 1px solid #ebeef5;
}

/* 课程标题 */
.course-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 5px 0 3px 0; /* 调整为2px，缩小间距 */
}

/* 课程价格样式 - 靠右对齐 */
.course-price {
    font-size: 16px;
    font-weight: bold;
    color: #ff5722;
    margin: 1px 0 10px 0;
    text-align: right;
}

/* 学习进度条容器 */
.progress-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

/* 进度标签样式 */
.progress-label {
    font-size: 14px;
    color: #333;
    margin-right: 10px;
    white-space: nowrap;
}

/* 底部区域样式 */
.bottom {
    padding: 10px 14px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fafafa;
}

/* 课程时间 */
.course-time {
    font-size: 12px;
    color: #999;
}

.no-record {
    width: 100%;
    text-align: center;
    color: #bbb;
    font-size: 18px;
    padding: 60px 0;
}
</style>
